import { useIntl } from 'react-intl';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import { CloseIcon } from 'assets/icons';

interface IActiveFiltersDisplay {
  activeFilters: IDeviceTemplateFilters[];
  clearFilters: (filtersLabels: IDeviceFilterLabel[]) => void;
}

const ActiveDeviceFiltersDisplay = ({ activeFilters, clearFilters }: IActiveFiltersDisplay) => {
  const { formatMessage } = useIntl();

  const displayFilter = (filter: IDeviceTemplateFilters, filterData: ISelectOption) => {
    return <span key={filterData.label}>{filterData.label}</span>;
  };

  const getCitcKey = (filterLabel: IDeviceFilterLabel) => {
    switch (filterLabel) {
      case 'subgroups':
        return 'groupsKey';
      case 'locations':
        return 'locationKey';
      case 'conditions':
        return 'conditionKey';
      case 'models':
        return 'modelKey';
      case 'types':
        return 'typeKey';
      case 'batteryLevel':
        return 'batteryLevelKey';
      case 'deviceStatus':
        return 'statusKey';
      default:
        return filterLabel;
    }
  };

  return (
    <div className="filterDisplay">
      {activeFilters.map((filter) => {
        if (filter.filterData) {
          return (
            <div key={filter.filterLabel} className="position-relative me-2">
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Popover id="popover-basic">
                    <Popover.Body className="filterPopoverContent">
                      {filter.filterData.map((data: any) => displayFilter(filter, data))}
                    </Popover.Body>
                  </Popover>
                }
              >
                <span className="filterDisplayMessage">
                  {formatMessage({ id: getCitcKey(filter.filterLabel) })}
                  <>&nbsp; ({filter.filterData.length})</>
                </span>
              </OverlayTrigger>
              <CloseIcon
                onClick={() => clearFilters([filter.filterLabel])}
                style={{ fontSize: '20px' }}
                className="icon filterDisplayCloseIcon"
              />
            </div>
          );
        }
      })}
    </div>
  );
};

export default ActiveDeviceFiltersDisplay;
